var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgServiceColor = function SvgServiceColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5389_8323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3242 7.95515L12.0223 9.64634L13.0943 8.57871C14.2478 9.06134 15.6295 8.83531 16.5693 7.89931C17.3863 7.08562 17.6654 5.93822 17.405 4.89718L15.6922 6.603C15.476 6.81838 15.1249 6.81838 14.9073 6.603L13.3787 5.08066C13.1624 4.86527 13.1624 4.5156 13.3787 4.29888L15.0928 2.59307C13.9941 2.32184 12.7793 2.64093 11.9583 3.55301C11.1279 4.47438 10.9437 5.78532 11.4002 6.88353L10.3256 7.95382L10.3242 7.95515Z",
    fill: "#33DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16742 11.0982L3.05163 15.1972C2.58305 15.6639 2.58305 16.4217 3.05163 16.8884C3.52022 17.3551 4.28116 17.3551 4.74975 16.8884L8.86553 12.7894L7.16742 11.0982Z",
    fill: "#33DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1661 14.1017L13.8552 11.8002C13.6403 11.5862 13.2905 11.5862 13.0756 11.8002L12.7806 12.094L7.89316 7.22656L7.54472 5.27345L4.92413 3.39346C4.73856 3.2605 4.48358 3.28045 4.32071 3.44265L2.63595 5.12055C2.47441 5.28142 2.45305 5.53537 2.58655 5.7215L4.4729 8.33141L6.43401 8.67843L11.3214 13.5459L11.0264 13.8397C10.8115 14.0538 10.8115 14.4021 11.0264 14.6162L13.3373 16.9177C14.1182 17.6954 15.3825 17.6954 16.1634 16.9177C16.9444 16.1399 16.9444 14.8808 16.1634 14.103L16.1661 14.1017Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5389_8323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgServiceColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "service-color.e18280f7bacc190c4ba928890aa128ec.svg";